import { createSlice } from "@reduxjs/toolkit";
import { isEqual } from "lodash";
const initialState = { widget: {} };
const slice = createSlice({
    initialState,
    name: "addWidgetReducers",
    reducers: {
        resetSearch: () => initialState,
        setDisabledFilters: (state, action) => {
            state.disabledFilters = action.payload.disabledFilters;
        },
        setSearchName: (state, action) => {
            state.name = action.payload.search;
        },
        setSelectedWidget: (state, action) => {
            if (action.payload.widgetId) {
                state.selectedWidgetId = action.payload.widgetId;
            }
        },
        updateSearchParam: (state, action) => {
            if (!state.searchParam) {
                state.searchParam = {};
            }
            const key = Object.keys(action.payload.search)?.[0], searchStateParam = state.searchParam;
            if (searchStateParam && key) {
                const items = action.payload.search[key];
                items.forEach((item) => {
                    if (item.checked) {
                        if (searchStateParam[key]) {
                            searchStateParam[key].push(item.label);
                        }
                        else {
                            searchStateParam[key] = [item.label];
                        }
                    }
                    else if (searchStateParam[key]) {
                        searchStateParam[key] = searchStateParam[key].filter((s) => !isEqual(s, item.label));
                        if (searchStateParam[key].length === 0) {
                            delete searchStateParam[key];
                        }
                    }
                });
            }
        }
    }
});
export const addWidgetReducer = slice.reducer;
export const { setDisabledFilters, updateSearchParam, setSearchName, setSelectedWidget, resetSearch } = slice.actions;
